import type { SVGProps } from 'react'

export const UserMetrics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="80"
    viewBox="0 0 81 80"
    width="81"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.4637 39.0325C36.1379 39.0325 32.6043 37.6617 29.8628 34.9202C27.1213 32.1787 25.7505 28.6451 25.7505 24.3193C25.7505 19.993 27.1213 16.4558 29.8628 13.7077C32.6043 10.959 36.1379 9.58466 40.4637 9.58466C44.79 9.58466 48.3359 10.959 51.1013 13.7077C53.8668 16.4558 55.2495 19.993 55.2495 24.3193C55.2495 28.6451 53.8668 32.1787 51.1013 34.9202C48.3359 37.6617 44.79 39.0325 40.4637 39.0325ZM10.5 63.3086V60.6138C10.5 58.1384 11.1295 55.9848 12.3884 54.1529C13.6479 52.3211 15.2884 50.933 17.3098 49.9886C21.3844 48.161 25.3115 46.7899 29.0913 45.8755C32.8704 44.9617 36.6603 44.5047 40.461 44.5047C44.3286 44.5047 48.1335 44.9766 51.8755 45.9203C55.617 46.8647 59.5083 48.2208 63.5494 49.9886C65.6396 50.8935 67.3207 52.2634 68.5928 54.0982C69.8643 55.9324 70.5 58.1043 70.5 60.6138V63.3086C70.5 65.2768 69.8113 66.9535 68.434 68.3386C67.0573 69.7231 65.36 70.4154 63.3421 70.4154H17.6067C15.6026 70.4154 13.917 69.7231 12.5498 68.3386C11.1833 66.9535 10.5 65.2768 10.5 63.3086Z"
      fill="url(#paint0_linear_2939_792)"
    />
    <foreignObject height="52" width="52" x="-6.5" y="-7">
      <div
        style={{
          backdropFilter: 'blur(3.5px)',
          clipPath: 'url(#bgblur_0_2939_792_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="7">
      <mask fill="white" id="path-2-inside-1_2939_792">
        <path d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0H30.5C34.9183 0 38.5 3.58172 38.5 8V30C38.5 34.4183 34.9183 38 30.5 38H8.5C4.08172 38 0.5 34.4183 0.5 30V8Z" />
      </mask>
      <path
        d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0H30.5C34.9183 0 38.5 3.58172 38.5 8V30C38.5 34.4183 34.9183 38 30.5 38H8.5C4.08172 38 0.5 34.4183 0.5 30V8Z"
        fill="url(#paint1_linear_2939_792)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint2_angular_2939_792_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-2-inside-1_2939_792)"
      >
        <g transform="matrix(2.61537e-10 0.019 -0.019 3.05022e-09 19.5 19)">
          <foreignObject
            height="2052.63"
            width="2052.63"
            x="-1026.32"
            y="-1026.32"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M8.5 0V0.5H30.5V0V-0.5H8.5V0ZM38.5 8H38V30H38.5H39V8H38.5ZM30.5 38V37.5H8.5V38V38.5H30.5V38ZM0.5 30H1V8H0.5H0V30H0.5ZM8.5 38V37.5C4.35786 37.5 1 34.1421 1 30H0.5H0C0 34.6944 3.80558 38.5 8.5 38.5V38ZM38.5 30H38C38 34.1421 34.6421 37.5 30.5 37.5V38V38.5C35.1944 38.5 39 34.6944 39 30H38.5ZM30.5 0V0.5C34.6421 0.5 38 3.85786 38 8H38.5H39C39 3.30558 35.1944 -0.5 30.5 -0.5V0ZM8.5 0V-0.5C3.80558 -0.5 0 3.30558 0 8H0.5H1C1 3.85786 4.35786 0.5 8.5 0.5V0Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:5.2307387932160054e-07,&#34;m01&#34;:-38.000007629394531,&#34;m02&#34;:38.500003814697266,&#34;m10&#34;:38.000003814697266,&#34;m11&#34;:6.1004334384051617e-06,&#34;m12&#34;:-5.3151925385463983e-06},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-2-inside-1_2939_792)"
      />
    </g>
    <path
      d="M10.6502 31C9.77852 31 9.03564 30.6962 8.42153 30.0887C7.80718 29.4812 7.5 28.7416 7.5 27.87V21.8502C7.5 20.9785 7.80718 20.239 8.42153 19.6314C9.03564 19.0239 9.77852 18.7202 10.6502 18.7202C11.5216 18.7202 12.261 19.0239 12.8686 19.6314C13.4761 20.239 13.7798 20.9785 13.7798 21.8502V27.87C13.7798 28.7416 13.4761 29.4812 12.8686 30.0887C12.261 30.6962 11.5216 31 10.6502 31ZM19.5 31C18.6418 31 17.9055 30.6928 17.2912 30.0785C16.6771 29.4644 16.37 28.7282 16.37 27.87V10.13C16.37 9.2718 16.6738 8.53564 17.2813 7.92153C17.8888 7.30717 18.6284 7 19.5 7C20.3582 7 21.0945 7.30717 21.7088 7.92153C22.3229 8.53564 22.63 9.2718 22.63 10.13V27.87C22.63 28.7282 22.3262 29.4644 21.7187 30.0785C21.1112 30.6928 20.3716 31 19.5 31ZM28.37 31C27.4984 31 26.7555 30.6962 26.1414 30.0887C25.5272 29.4812 25.2202 28.7416 25.2202 27.87V17.2051C25.2202 16.3334 25.5272 15.5938 26.1414 14.9863C26.7555 14.3788 27.4984 14.0751 28.37 14.0751C29.2416 14.0751 29.9812 14.3788 30.5887 14.9863C31.1962 15.5938 31.5 16.3334 31.5 17.2051V27.87C31.5 28.7416 31.1962 29.4812 30.5887 30.0887C29.9812 30.6962 29.2416 31 28.37 31Z"
      fill="url(#paint3_linear_2939_792)"
      opacity="0.9"
    />
    <foreignObject height="52" width="52" x="35.5" y="-7">
      <div
        style={{
          backdropFilter: 'blur(3.5px)',
          clipPath: 'url(#bgblur_1_2939_792_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="7">
      <mask fill="white" id="path-5-inside-2_2939_792">
        <path d="M42.5 8C42.5 3.58172 46.0817 0 50.5 0H72.5C76.9183 0 80.5 3.58172 80.5 8V30C80.5 34.4183 76.9183 38 72.5 38H50.5C46.0817 38 42.5 34.4183 42.5 30V8Z" />
      </mask>
      <path
        d="M42.5 8C42.5 3.58172 46.0817 0 50.5 0H72.5C76.9183 0 80.5 3.58172 80.5 8V30C80.5 34.4183 76.9183 38 72.5 38H50.5C46.0817 38 42.5 34.4183 42.5 30V8Z"
        fill="url(#paint4_linear_2939_792)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint5_angular_2939_792_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-5-inside-2_2939_792)"
      >
        <g transform="matrix(2.61537e-10 0.019 -0.019 3.05022e-09 61.5 19)">
          <foreignObject
            height="2052.63"
            width="2052.63"
            x="-1026.32"
            y="-1026.32"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M50.5 0V0.5H72.5V0V-0.5H50.5V0ZM80.5 8H80V30H80.5H81V8H80.5ZM72.5 38V37.5H50.5V38V38.5H72.5V38ZM42.5 30H43V8H42.5H42V30H42.5ZM50.5 38V37.5C46.3579 37.5 43 34.1421 43 30H42.5H42C42 34.6944 45.8056 38.5 50.5 38.5V38ZM80.5 30H80C80 34.1421 76.6421 37.5 72.5 37.5V38V38.5C77.1944 38.5 81 34.6944 81 30H80.5ZM72.5 0V0.5C76.6421 0.5 80 3.85786 80 8H80.5H81C81 3.30558 77.1944 -0.5 72.5 -0.5V0ZM50.5 0V-0.5C45.8056 -0.5 42 3.30558 42 8H42.5H43C43 3.85786 46.3579 0.5 50.5 0.5V0Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:5.2307387932160054e-07,&#34;m01&#34;:-38.000007629394531,&#34;m02&#34;:80.50,&#34;m10&#34;:38.000003814697266,&#34;m11&#34;:6.1004334384051617e-06,&#34;m12&#34;:-5.3151925385463983e-06},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-5-inside-2_2939_792)"
      />
    </g>
    <mask
      height="20"
      id="mask0_2939_792"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha'
      }}
      width="21"
      x="51"
      y="9"
    >
      <rect fill="#D9D9D9" height="20" width="20" x="51.5" y="9" />
    </mask>
    <g mask="url(#mask0_2939_792)">
      <path
        d="M60.4792 20.0208H57.1204C56.8374 20.0208 56.5965 19.9219 56.3977 19.724C56.199 19.5262 56.0996 19.2863 56.0996 19.0044C56.0996 18.7224 56.199 18.4811 56.3977 18.2804C56.5965 18.0796 56.8374 17.9792 57.1204 17.9792H60.4792V14.6204C60.4792 14.3374 60.5781 14.0965 60.776 13.8977C60.9738 13.699 61.2137 13.5996 61.4956 13.5996C61.7776 13.5996 62.0189 13.699 62.2196 13.8977C62.4204 14.0965 62.5208 14.3374 62.5208 14.6204V17.9792H65.8796C66.1626 17.9792 66.4035 18.0781 66.6023 18.276C66.801 18.4738 66.9004 18.7137 66.9004 18.9956C66.9004 19.2776 66.801 19.5189 66.6023 19.7196C66.4035 19.9204 66.1626 20.0208 65.8796 20.0208H62.5208V23.3796C62.5208 23.6626 62.4219 23.9035 62.224 24.1023C62.0262 24.301 61.7863 24.4004 61.5044 24.4004C61.2224 24.4004 60.9811 24.301 60.7804 24.1023C60.5796 23.9035 60.4792 23.6626 60.4792 23.3796V20.0208Z"
        fill="url(#paint6_linear_2939_792)"
        opacity="0.9"
      />
    </g>
    <foreignObject height="52" width="52" x="-6.5" y="35">
      <div
        style={{
          backdropFilter: 'blur(3.5px)',
          clipPath: 'url(#bgblur_2_2939_792_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="7">
      <mask fill="white" id="path-9-inside-3_2939_792">
        <path d="M0.5 50C0.5 45.5817 4.08172 42 8.5 42H30.5C34.9183 42 38.5 45.5817 38.5 50V72C38.5 76.4183 34.9183 80 30.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V50Z" />
      </mask>
      <path
        d="M0.5 50C0.5 45.5817 4.08172 42 8.5 42H30.5C34.9183 42 38.5 45.5817 38.5 50V72C38.5 76.4183 34.9183 80 30.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V50Z"
        fill="url(#paint7_linear_2939_792)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint8_angular_2939_792_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-9-inside-3_2939_792)"
      >
        <g transform="matrix(2.61537e-10 0.019 -0.019 3.05022e-09 19.5 61)">
          <foreignObject
            height="2052.63"
            width="2052.63"
            x="-1026.32"
            y="-1026.32"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M8.5 42V42.5H30.5V42V41.5H8.5V42ZM38.5 50H38V72H38.5H39V50H38.5ZM30.5 80V79.5H8.5V80V80.5H30.5V80ZM0.5 72H1V50H0.5H0V72H0.5ZM8.5 80V79.5C4.35786 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM38.5 72H38C38 76.1421 34.6421 79.5 30.5 79.5V80V80.5C35.1944 80.5 39 76.6944 39 72H38.5ZM30.5 42V42.5C34.6421 42.5 38 45.8579 38 50H38.5H39C39 45.3056 35.1944 41.5 30.5 41.5V42ZM8.5 42V41.5C3.80558 41.5 0 45.3056 0 50H0.5H1C1 45.8579 4.35786 42.5 8.5 42.5V42Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:5.2307387932160054e-07,&#34;m01&#34;:-38.000007629394531,&#34;m02&#34;:38.500003814697266,&#34;m10&#34;:38.000003814697266,&#34;m11&#34;:6.1004334384051617e-06,&#34;m12&#34;:41.999996185302734},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-9-inside-3_2939_792)"
      />
    </g>
    <path
      d="M19.5 72.6981C17.8405 72.6981 16.2819 72.3841 14.8242 71.7561C13.3664 71.1279 12.0953 70.2716 11.0108 69.1873C9.92651 68.1028 9.07025 66.8317 8.44204 65.3739C7.81401 63.9162 7.5 62.3576 7.5 60.6981C7.5 58.1742 8.21561 55.8848 9.64684 53.8299C11.0781 51.7753 12.9823 50.3136 15.3595 49.4449C16.0098 49.2001 16.6228 49.2696 17.1983 49.6533C17.7737 50.0371 18.0613 50.5703 18.0613 51.2531C18.0613 51.7428 17.9327 52.1828 17.6755 52.573C17.4182 52.9635 17.0802 53.2321 16.6613 53.3788C15.1818 53.8725 13.9816 54.7964 13.0606 56.1505C12.1397 57.5047 11.6792 59.0205 11.6792 60.6981C11.6792 62.8661 12.4407 64.7116 13.9637 66.2344C15.4865 67.7574 17.332 68.5189 19.5 68.5189C20.4276 68.5189 21.3111 68.3714 22.1504 68.0764C22.9894 67.7814 23.7554 67.3527 24.4483 66.7903C24.8317 66.4691 25.277 66.3004 25.7842 66.2842C26.2917 66.268 26.7101 66.4097 27.0394 66.7093C27.5862 67.1963 27.8637 67.7682 27.8721 68.425C27.8803 69.0817 27.6111 69.6278 27.0643 70.0635C25.9476 70.9495 24.7682 71.6101 23.5261 72.0452C22.2841 72.4805 20.9421 72.6981 19.5 72.6981ZM27.3208 60.6981C27.3208 59.0612 26.8609 57.5737 25.9411 56.2358C25.0215 54.8979 23.8112 53.9456 22.3101 53.3788C21.8912 53.2105 21.5531 52.9338 21.2959 52.5487C21.0387 52.1638 20.91 51.7319 20.91 51.2531C20.91 50.5919 21.1924 50.0694 21.757 49.6857C22.3217 49.3019 22.94 49.2217 23.6119 49.4449C25.9757 50.2248 27.8814 51.6503 29.3288 53.7212C30.7763 55.792 31.5 58.1177 31.5 60.6981C31.5 60.9769 31.4857 61.2685 31.4571 61.5729C31.4284 61.8774 31.3867 62.2127 31.332 62.5787C31.2257 63.2291 30.893 63.7059 30.3338 64.0091C29.7745 64.3125 29.1642 64.3431 28.503 64.1007C28.0542 63.9456 27.7053 63.651 27.4565 63.2171C27.2075 62.7831 27.1265 62.3268 27.2138 61.848C27.2601 61.5991 27.2895 61.3857 27.3019 61.2076C27.3145 61.0298 27.3208 60.8599 27.3208 60.6981Z"
      fill="url(#paint9_linear_2939_792)"
      opacity="0.9"
    />
    <foreignObject height="52" width="52" x="35.5" y="35">
      <div
        style={{
          backdropFilter: 'blur(3.5px)',
          clipPath: 'url(#bgblur_3_2939_792_clip_path)',
          height: '100%',
          width: '100%'
        }}
      ></div>
    </foreignObject>
    <g data-figma-bg-blur-radius="7">
      <mask fill="white" id="path-12-inside-4_2939_792">
        <path d="M42.5 50C42.5 45.5817 46.0817 42 50.5 42H72.5C76.9183 42 80.5 45.5817 80.5 50V72C80.5 76.4183 76.9183 80 72.5 80H50.5C46.0817 80 42.5 76.4183 42.5 72V50Z" />
      </mask>
      <path
        d="M42.5 50C42.5 45.5817 46.0817 42 50.5 42H72.5C76.9183 42 80.5 45.5817 80.5 50V72C80.5 76.4183 76.9183 80 72.5 80H50.5C46.0817 80 42.5 76.4183 42.5 72V50Z"
        fill="url(#paint10_linear_2939_792)"
        fillOpacity="0.4"
      />
      <g
        clipPath="url(#paint11_angular_2939_792_clip_path)"
        data-figma-skip-parse="true"
        mask="url(#path-12-inside-4_2939_792)"
      >
        <g transform="matrix(2.61537e-10 0.019 -0.019 3.05022e-09 61.5 61)">
          <foreignObject
            height="2052.63"
            width="2052.63"
            x="-1026.32"
            y="-1026.32"
          >
            <div
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(255, 255, 255, 0.5692) 0deg,rgba(255, 255, 255, 0.8) 34.616deg,rgba(255, 255, 255, 0.2) 72.6934deg,rgba(255, 255, 255, 0.8) 124.617deg,rgba(255, 255, 255, 0.2) 304.62deg,rgba(255, 255, 255, 0.5692) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        d="M50.5 42V42.5H72.5V42V41.5H50.5V42ZM80.5 50H80V72H80.5H81V50H80.5ZM72.5 80V79.5H50.5V80V80.5H72.5V80ZM42.5 72H43V50H42.5H42V72H42.5ZM50.5 80V79.5C46.3579 79.5 43 76.1421 43 72H42.5H42C42 76.6944 45.8056 80.5 50.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 42V42.5C76.6421 42.5 80 45.8579 80 50H80.5H81C81 45.3056 77.1944 41.5 72.5 41.5V42ZM50.5 42V41.5C45.8056 41.5 42 45.3056 42 50H42.5H43C43 45.8579 46.3579 42.5 50.5 42.5V42Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.096155457198619843},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.20192614197731018},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.80000001192092896},&#34;position&#34;:0.34615889191627502},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.20000000298023224},&#34;position&#34;:0.84616577625274658}],&#34;transform&#34;:{&#34;m00&#34;:5.2307387932160054e-07,&#34;m01&#34;:-38.000007629394531,&#34;m02&#34;:80.50,&#34;m10&#34;:38.000003814697266,&#34;m11&#34;:6.1004334384051617e-06,&#34;m12&#34;:41.999996185302734},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        mask="url(#path-12-inside-4_2939_792)"
      />
    </g>
    <path
      d="M73.5 68.3984L63.1479 60.3104C62.5759 59.8617 61.9342 59.6857 61.2229 59.7824C60.5116 59.8793 59.9434 60.2254 59.5182 60.8207L56.2249 65.3521C56.0078 65.6545 55.7232 65.8305 55.3712 65.8801C55.0192 65.93 54.6965 65.8391 54.4031 65.6073L49.5 61.7468V59.3168C49.5 58.783 49.734 58.4001 50.202 58.1684C50.6698 57.9368 51.1164 57.9794 51.5418 58.2961L54.6042 60.5927L60.0692 52.9286C60.4946 52.3331 61.0711 51.9833 61.7986 51.8793C62.5261 51.7753 63.1759 51.955 63.7479 52.4182L68.3146 56.0588H70.9479C71.6519 56.0588 72.2533 56.3081 72.7521 56.8067C73.2507 57.3055 73.5 57.907 73.5 58.611V68.3984ZM49.5 73V64.3801L53.7759 67.8118C54.3479 68.2751 54.9918 68.4547 55.7075 68.3507C56.4235 68.2467 56.9941 67.897 57.4193 67.3014L60.7345 62.7619C60.9516 62.4598 61.234 62.2838 61.5815 62.2339C61.9291 62.1842 62.2494 62.2752 62.5426 62.5067L73.5 71.067V73H49.5Z"
      fill="url(#paint12_linear_2939_792)"
      opacity="0.9"
    />
    <defs>
      <clipPath id="bgblur_0_2939_792_clip_path" transform="translate(6.5 7)">
        <path d="M0.5 8C0.5 3.58172 4.08172 0 8.5 0H30.5C34.9183 0 38.5 3.58172 38.5 8V30C38.5 34.4183 34.9183 38 30.5 38H8.5C4.08172 38 0.5 34.4183 0.5 30V8Z" />
      </clipPath>
      <clipPath id="paint2_angular_2939_792_clip_path">
        <path
          d="M8.5 0V0.5H30.5V0V-0.5H8.5V0ZM38.5 8H38V30H38.5H39V8H38.5ZM30.5 38V37.5H8.5V38V38.5H30.5V38ZM0.5 30H1V8H0.5H0V30H0.5ZM8.5 38V37.5C4.35786 37.5 1 34.1421 1 30H0.5H0C0 34.6944 3.80558 38.5 8.5 38.5V38ZM38.5 30H38C38 34.1421 34.6421 37.5 30.5 37.5V38V38.5C35.1944 38.5 39 34.6944 39 30H38.5ZM30.5 0V0.5C34.6421 0.5 38 3.85786 38 8H38.5H39C39 3.30558 35.1944 -0.5 30.5 -0.5V0ZM8.5 0V-0.5C3.80558 -0.5 0 3.30558 0 8H0.5H1C1 3.85786 4.35786 0.5 8.5 0.5V0Z"
          mask="url(#path-2-inside-1_2939_792)"
        />
      </clipPath>
      <clipPath id="bgblur_1_2939_792_clip_path" transform="translate(-35.5 7)">
        <path d="M42.5 8C42.5 3.58172 46.0817 0 50.5 0H72.5C76.9183 0 80.5 3.58172 80.5 8V30C80.5 34.4183 76.9183 38 72.5 38H50.5C46.0817 38 42.5 34.4183 42.5 30V8Z" />
      </clipPath>
      <clipPath id="paint5_angular_2939_792_clip_path">
        <path
          d="M50.5 0V0.5H72.5V0V-0.5H50.5V0ZM80.5 8H80V30H80.5H81V8H80.5ZM72.5 38V37.5H50.5V38V38.5H72.5V38ZM42.5 30H43V8H42.5H42V30H42.5ZM50.5 38V37.5C46.3579 37.5 43 34.1421 43 30H42.5H42C42 34.6944 45.8056 38.5 50.5 38.5V38ZM80.5 30H80C80 34.1421 76.6421 37.5 72.5 37.5V38V38.5C77.1944 38.5 81 34.6944 81 30H80.5ZM72.5 0V0.5C76.6421 0.5 80 3.85786 80 8H80.5H81C81 3.30558 77.1944 -0.5 72.5 -0.5V0ZM50.5 0V-0.5C45.8056 -0.5 42 3.30558 42 8H42.5H43C43 3.85786 46.3579 0.5 50.5 0.5V0Z"
          mask="url(#path-5-inside-2_2939_792)"
        />
      </clipPath>
      <clipPath id="bgblur_2_2939_792_clip_path" transform="translate(6.5 -35)">
        <path d="M0.5 50C0.5 45.5817 4.08172 42 8.5 42H30.5C34.9183 42 38.5 45.5817 38.5 50V72C38.5 76.4183 34.9183 80 30.5 80H8.5C4.08172 80 0.5 76.4183 0.5 72V50Z" />
      </clipPath>
      <clipPath id="paint8_angular_2939_792_clip_path">
        <path
          d="M8.5 42V42.5H30.5V42V41.5H8.5V42ZM38.5 50H38V72H38.5H39V50H38.5ZM30.5 80V79.5H8.5V80V80.5H30.5V80ZM0.5 72H1V50H0.5H0V72H0.5ZM8.5 80V79.5C4.35786 79.5 1 76.1421 1 72H0.5H0C0 76.6944 3.80558 80.5 8.5 80.5V80ZM38.5 72H38C38 76.1421 34.6421 79.5 30.5 79.5V80V80.5C35.1944 80.5 39 76.6944 39 72H38.5ZM30.5 42V42.5C34.6421 42.5 38 45.8579 38 50H38.5H39C39 45.3056 35.1944 41.5 30.5 41.5V42ZM8.5 42V41.5C3.80558 41.5 0 45.3056 0 50H0.5H1C1 45.8579 4.35786 42.5 8.5 42.5V42Z"
          mask="url(#path-9-inside-3_2939_792)"
        />
      </clipPath>
      <clipPath
        id="bgblur_3_2939_792_clip_path"
        transform="translate(-35.5 -35)"
      >
        <path d="M42.5 50C42.5 45.5817 46.0817 42 50.5 42H72.5C76.9183 42 80.5 45.5817 80.5 50V72C80.5 76.4183 76.9183 80 72.5 80H50.5C46.0817 80 42.5 76.4183 42.5 72V50Z" />
      </clipPath>
      <clipPath id="paint11_angular_2939_792_clip_path">
        <path
          d="M50.5 42V42.5H72.5V42V41.5H50.5V42ZM80.5 50H80V72H80.5H81V50H80.5ZM72.5 80V79.5H50.5V80V80.5H72.5V80ZM42.5 72H43V50H42.5H42V72H42.5ZM50.5 80V79.5C46.3579 79.5 43 76.1421 43 72H42.5H42C42 76.6944 45.8056 80.5 50.5 80.5V80ZM80.5 72H80C80 76.1421 76.6421 79.5 72.5 79.5V80V80.5C77.1944 80.5 81 76.6944 81 72H80.5ZM72.5 42V42.5C76.6421 42.5 80 45.8579 80 50H80.5H81C81 45.3056 77.1944 41.5 72.5 41.5V42ZM50.5 42V41.5C45.8056 41.5 42 45.3056 42 50H42.5H43C43 45.8579 46.3579 42.5 50.5 42.5V42Z"
          mask="url(#path-12-inside-4_2939_792)"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2939_792"
        x1="40.5"
        x2="40.5"
        y1="9.58466"
        y2="70.4154"
      >
        <stop stopColor="#77ACFF" />
        <stop offset="1" stopColor="#4691F4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2939_792"
        x1="19.5"
        x2="19.5"
        y1="0"
        y2="38"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_2939_792"
        x1="19.5"
        x2="14.8577"
        y1="7"
        y2="30.0657"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint4_linear_2939_792"
        x1="61.5"
        x2="61.5"
        y1="0"
        y2="38"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint6_linear_2939_792"
        x1="61.5"
        x2="59.4108"
        y1="13.5996"
        y2="23.9799"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint7_linear_2939_792"
        x1="19.5"
        x2="19.5"
        y1="42"
        y2="80"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint9_linear_2939_792"
        x1="19.5"
        x2="15.0798"
        y1="49.3019"
        y2="71.8309"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint10_linear_2939_792"
        x1="61.5"
        x2="61.5"
        y1="42"
        y2="80"
      >
        <stop stopColor="#A8C8FF" />
        <stop offset="1" stopColor="#77ACFF" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint12_linear_2939_792"
        x1="61.5"
        x2="57.8634"
        y1="51.8507"
        y2="72.355"
      >
        <stop stopColor="white" stopOpacity="0.8" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
)
